import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";

const CharacterStyled = styled("div")({
  boxSizing: "border-box",
  borderRadius: 30,
  backgroundColor: "#fff",
  backgroundImage: ({ gradientFrom }) =>
    `linear-gradient(180deg, ${gradientFrom} 0%, #FFFFFF 49.48%)`,
});
export const Content = styled("div")({
  padding: "20px 30px 30px",
});
export const Image = styled("img")({ display: "block", marginBottom: 20 });
export const Title = styled("div")(
  css({
    fontSize: 4,
    fontWeight: 400,
    marginBottom: 20,
  })
);
export const Description = styled("div")(
  css({
    fontSize: 3,
  })
);

export const Character = ({ name, imageSrc, children, ...props }) => (
  <CharacterStyled {...props}>
    <Content>
      <Image src={imageSrc} />
      <Title>{name}</Title>
      <Description>{children}</Description>
    </Content>
  </CharacterStyled>
);
